import { apiSahCategories } from '~constants/api';

import { get } from '~libs/genericAction';
import { createThunks, Params } from '~libs/reduxUtils';

export const typePrefix = 'sah-categories';

const config = [
  { actionType: 'getAll', apiPath: apiSahCategories, method: get },
  { actionType: 'getOne', apiPath: (params: Params) => `${apiSahCategories}/${params.id}`, method: get },
];

export const { getAll, getOne } = createThunks(typePrefix, config);
